import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export default function LabelTextInline(props) {
  const {
    className = '',
    label,
    content
  } = props;
  let contentModified;
  if (typeof content !== 'string') {
    if (isEmpty(content)) {
      return null;
    }
    if (Array.isArray(content)) {
      contentModified = content.map(item => get(item, 'displayName', '') || get(item, 'name', '') || item).join(', ');
    }
  }
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [/*#__PURE__*/_jsxs("h4", {
      className: "font-heavy-font",
      children: [label, ":"]
    }), "\xA0", /*#__PURE__*/_jsx("span", {
      className: "font-regular-font",
      children: contentModified || content
    })]
  });
}
LabelTextInline.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node.isRequired,
  /** Array or String, Object in array should be formatted like { name: value }, string is value, value, value */
  content: PropTypes.any.isRequired
};
//# sourceMappingURL=LabelTextInline.js.map